import { NgIf } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserLike } from 'src/app/services/avatar.service';
import { AvatarTypePipe } from '../../../pipes/avatar-type.pipe';
import { AvatarPipe } from '../../../shared-extra/pipes/avatar.pipe';
import { SvgComponent } from '../svg/svg.component';

@Component({
  selector: 'app-avatar',
  standalone: true,
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  imports: [AvatarPipe, AvatarTypePipe, SvgComponent, NgIf],
})
export class AvatarComponent {
  @Input({ required: true }) user: UserLike;
  @Input() tempName: string;
  public sanitization = inject(DomSanitizer);
}
